const ROLE_GUEST = 'ROLE_GUEST';
const ROLE_ACCOMMODATION_PROVIDER = 'ROLE_ACCOMMODATION_PROVIDER';
const ROLE_PARTNER = 'ROLE_PARTNER';
const ROLE_UNAUTHENTICATED_GUEST = 'ROLE_UNAUTHENTICATED_GUEST';

export { ROLE_GUEST, ROLE_ACCOMMODATION_PROVIDER, ROLE_PARTNER, ROLE_UNAUTHENTICATED_GUEST };
